module.exports = __webpack_public_path__ + "img/Watney5.86d8ecaf.png";